/// <amd-module name="typeahead/core/presentation/SvgIcons" />
export class SvgIcons {
    public static init() {
        if (!SvgIcons.initialized) {
            let div = document.createElement("div");
            div.setAttribute("aria-hidden", "true");
            div.setAttribute("style", "display:none");
            div.innerHTML = SvgIcons.svgSprite;
            document.body.insertBefore(div, document.body.childNodes[0]);
            SvgIcons.initialized = true;

            let style = document.createElement("style");
            style.type = "text/css";
            style.innerHTML = `.icon > .uitk-icon-svg 
            {fill:currentcolor;height:1em;width:1em;pointer-events:none;position:relative;top:0.15em;}`;
            document.head.appendChild(style);
        }
    }

    private  static initialized: boolean = false;

    private static svgSprite: string = `
    <svg xmlns="http://www.w3.org/2000/svg">
    <symbol id="uitk-icon-location" viewBox="0 0 18 18"><path d="M9 0C5.8 0 3.3 2.6 3.3 5.7V6C3.5 11.5 9 18 9 18s5.5-6.5
     5.7-11.9v-.3C14.7 2.6 12.2 0 9 0zm0 8.3c-1.4 0-2.6-1.2-2.6-2.6S7.6 3.1 9 3.1s2.6 1.2 2.6 2.6S10.4 8.3 9 8.3z"/>
    </symbol>
    <symbol id="uitk-icon-flights" viewBox="0 0 18 18"><path d="M1.2 11.1l2.7.9 3.8-3.8L.1 
    3.9l1.1-1.1c.1-.1.2-.1.4-.1l8.7 2.8L14.8 1c.6-.6 1.5-.9 2.3-1 .2 0 .5 0 .7.2.2.2.3.4.2.7-.1.7-.4 1.7-1 2.3l-4.5 4.5 
    2.8 8.7c0 .1 0 .3-.1.4l-1.1 1.1-4.3-7.5L6 14.1l.9 2.7-1.1 1.1-2.3-3.4-3.4-2.3 1.1-1.1z"/></symbol>
    <symbol id="uitk-icon-hotels" viewBox="0 0 18 18"><path d="M17.7 
    17.5l-.4-1c-.1-.1-.2-.2-.3-.2h-.8V4.9c0-.2-.2-.4-.4-.4h-3.4V.4c0-.2-.2-.4-.4-.4H2.2c-.2 0-.3.2-.3.4v15.9h-.8c-.1 
    0-.3.1-.3.2l-.4 1c-.1.1 0 .2 0 .4s.2.1.3.1h16.6c.1 0 
    .2-.1.3-.2s.1-.2.1-.3zm-11.3-4H4.1v-2.2h2.2v2.2zm0-4.5H4.1V6.8h2.2V9zm0-4.5H4.1V2.2h2.2v2.3zM10.1 
    16H7.9v-4.8h2.2V16zm0-7H7.9V6.8h2.2V9zm0-4.5H7.9V2.2h2.2v2.3zm3.8 9h-2.2v-2.2h2.2v2.2zm0-4.5h-2.2V6.8h2.2V9z"/>
    </symbol>
    <symbol id="uitk-icon-cars" viewBox="0 0 18 18"><path d="M17.8 8.3l-1.5-1.4L14.8 2c0-.2-.2-.3-.4-.3H3.6c-.2 
    0-.3.1-.4.3L1.6 6.9.2 8.3s-.1.1-.1.2V13c0 .1 0 .2.1.3l.6.6V16c0 .2.2.4.4.4h3c.2 0 .4-.2.4-.4v-2.1h8.9V16c0 
    .2.2.4.4.4h3c.2 0 .4-.2.4-.4v-2.1l.6-.6c.1-.1.1-.2.1-.3V8.5l-.2-.2zM4.4 3.2h9.3l1.1 3.7H3.3l1.1-3.7zm-.8 8.2c-.8 
    0-1.5-.7-1.5-1.5 0-.9.7-1.5 1.5-1.5S5 9 5 9.9c0 .8-.6 1.5-1.4 1.5zm10.8 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.6 
    1.5 1.5c0 .8-.7 1.5-1.5 1.5z"/></symbol>
    <symbol id="uitk-icon-train" viewBox="0 0 18 18"><path d="M3.8 18l1-2.5h2l-.2 1h5l-.2-1h2l1 2.5H3.8zm9-18c.8 0 1.5.7
     1.5 1.5v12.1c0 .2-.2.4-.4.4H4.1c-.2 0-.4-.2-.4-.4V1.5C3.8.7 4.4 0 5.2 0h7.6zM6.5 2.6c0 .2.2.4.4.4h4.2c.2 0 
     .4-.2.4-.4v-.7c0-.2-.2-.4-.4-.4H6.9c-.2 0-.4.2-.4.4v.7zm.8 8.9c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1zm5.5 
     0c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1zm0-7H5.3v4.8h7.5V4.5z"/></symbol>
    <symbol id="uitk-icon-notime" viewBox="0 0 18 18"><path d="M17.4 9c0 4-3.2 7.2-7.2 7.2V14c2.8 0 5-2.3 5-5 
    0-2.8-2.3-5-5-5s-4.9 2.2-5 4.8v.8l.1-.4.9-1c.1-.1.2-.1.3-.1s.2 0 .3.1l1 1c.1.1.1.2.1.3s0 .2-.1.3l-3.6 3.6L.5 
    9.8c-.1-.1-.1-.2-.1-.3s0-.2.1-.3l1-1c.1-.1.2-.1.3-.1s.2 0 .3.1l.8.9.2.5v-.7c0-4 3.2-7.2 7.2-7.2S17.4 5 17.4 
    9zm-4.1-.5l-2.4-.2-.2-2.9h-1l-.2 4.3 3.8-.2v-1z"/></symbol>
    <symbol id="uitk-icon-tag" viewBox="0 0 18 18"><path d="M7.928.111A.376.376 0 0 0 7.661 0H3.434a.37.37 0 0 
    0-.267.111L.11 3.168a.376.376 0 0 0-.111.267v4.227a.37.37 0 0 0 .111.267l9.961 9.961a.38.38 0 0 0 .535 
    0l7.284-7.284a.38.38 0 0 0 0-.535L7.928.111zm-3.39 5.942a1.514 1.514 0 1 1 .002-3.028 1.514 1.514 0 0 1-.002 
    3.028z"/></symbol>
    <symbol id="uitk-icon-return" viewBox="0 0 18 18"><path d="M18 10.8c0 .1 0 .2-.1.3l-5 4.9c-.2.2-.4.2-.6 
    0l-1.1-1.1c-.2-.2-.2-.4 0-.6l2-2 .5-.2H.5c-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.3V2.3c0-.1 0-.2.1-.3s.2-.1.3-.1h1.6c.1 0 
    .2 0 .3.1.1 0 .1.1.1.3v7.3h11.3l-.5-.2-2-2c-.3-.2-.3-.4-.1-.6l1.1-1.1c.2-.2.4-.2.6 0l4.9 4.9c.1 0 .1.1.2.2z"/>
    </symbol>
    <symbol id="uitk-icon-close" viewBox="0 0 18 18"><path d="M14.4 
    5.9c.1-.1.1-.2.1-.3s0-.2-.1-.3l-1.7-1.7c-.2-.2-.4-.2-.6 0L9 6.7 5.9 3.6c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3.1L3.6 
    5.3c-.2.2-.2.4 0 .6L6.7 9l-3.1 3.1c-.1.1-.1.2-.1.3s0 .2.1.3l1.7 1.7c.2.2.4.2.6 0L9 11.3l3.1 3.1c.2.2.4.2.6 
    0l1.7-1.7c.1-.1.1-.2.1-.3s0-.2-.1-.3L11.3 9l3.1-3.1z"/></symbol>
    </svg>`;
}
